import React from 'react';
import { styles } from './ProductFulfilmentPdp.css';
import { ProductFulfilmentInfo, ProductFulfilmentInfoProps } from './ProductFulfilmentInfo';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export interface ProductFulfilmentPdpProps extends ProductFulfilmentInfoProps {
  isLocationSet: boolean;
}

export const ProductFulfilmentPdp = (props: ProductFulfilmentPdpProps) => {
  return (
    <div className={styles.wrapper} id="pdpLocalisationComponent">
      <div id="pdpLocalisationLabel">
        <CalloutFont className={styles.title} testId="pdp-localisation-label-text">
          Getting your item
        </CalloutFont>
      </div>
      <ProductFulfilmentInfo {...props} />
    </div>
  );
};
